import api_config from '../config/api'

export default {
	async addCategory(form_data, token) {
		return api_config.post('api/category', form_data, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
	},
	async deleteCategory(id, token) {
		return api_config.delete(`api/category/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
	},
	getCategories(language) {
		return api_config.get(`api/category/${language}`)
	},
	async updateCategory({ id, form_data }, token) {
		return api_config.post(`api/category/${id}`, form_data, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
	},
}
